/**
 * Sidebar Navigation Component
 * - Collapsible navigation menu
 * - Responsive design for mobile/desktop
 * - Active route highlighting
 * - Support contact section
 */

import { NavLink, useLocation } from "react-router-dom";
import HLLogo from "../../assets/HLLogo.jpg";
import { X } from "lucide-react"; // close icon

const Sidebar = ({ items, isSidebarOpen, closeMobileSidebar }) => {
  const location = useLocation();

  return (
  <aside
  className={`${
    isSidebarOpen ? "w-64" : "w-20"
  } bg-white shadow-lg transition-all duration-300 flex flex-col h-full`}
>
  {/* Logo + Close for mobile/tablet */}
  <div className="px-6 py-6 flex justify-between items-center border-b-gray-300 border-b">
    {isSidebarOpen ? (
      <img src={HLLogo} alt="HLLogo" className="h-8 w-40" />
    ) : (
      <h1>HL</h1>
    )}
    <button className="lg:hidden text-gray-600" onClick={closeMobileSidebar}>
      <X className="w-5 h-5" />
    </button>
  </div>

  {/* Navigation */}
  <nav className="flex flex-col p-2 space-y-2 flex-grow">
    {items.map((item) => {
      let isActive = location.pathname.startsWith(item.path);
      if (item.label === "User Management") {
        isActive =
          location.pathname.startsWith("/swift-app/admin/users") ||
          location.pathname.startsWith("/swift-app/admin/profile");
      }

      return (
        <div key={item.path} className="relative group">
          <NavLink
            to={item.path}
            onClick={closeMobileSidebar}
            className={`flex items-center rounded-md px-3 py-2 text-sm font-medium transition
              ${
                isActive
                  ? "bg-blue-50 text-blue-600"
                  : "text-gray-700 hover:bg-blue-50 hover:text-blue-600"
              }
              ${isSidebarOpen ? "justify-between" : "justify-center"}
            `}
          >
            <div className="flex items-center text-base">
              {item.icon && <item.icon className="h-5 w-5" />}
              {isSidebarOpen && <span className="ml-3">{item.label}</span>}
            </div>
            {isActive && isSidebarOpen && (
              <span className="h-2 w-2 rounded-full bg-blue-600" />
            )}
          </NavLink>

          {!isSidebarOpen && (
            <span className="absolute left-full top-1/2 -translate-y-1/2 ml-3 px-2 py-1 text-xs bg-gray-800/80 text-white rounded opacity-0 group-hover:opacity-100 whitespace-nowrap transition-opacity duration-200 z-50">
              {item.label}
            </span>
          )}
        </div>
      );
    })}
  </nav>

  {/* Support Card (Below Settings) */}
  <hr className="text-gray-200 mx-4"/>
  <div className="p-4">
    <div className="bg-gray-50 border border-gray-200 shadow-sm rounded-lg p-4">
      {isSidebarOpen ? (
        <>
          <h3 className="text-sm font-semibold text-gray-800">Need Help?</h3>
          <p className="text-xs text-gray-500 mt-1">Get support from our team</p>

          <button className="mt-3 w-full bg-blue-600 hover:bg-blue-700 text-white text-sm py-2 rounded-md">
            Contact Support
          </button>
        </>
      ) : (
        <div className="flex justify-center">
          <button className="bg-blue-600 hover:bg-blue-700 text-white text-xs px-3 py-2 rounded-md">
            ?
          </button>
        </div>
      )}
    </div>
  </div>
</aside>

  );
};

export default Sidebar;
